import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";
import ReactMarkdown from "react-markdown";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const postQuery = query(
          collection(db, "blog_posts"),
          where("slug", "==", slug)
        );

        const querySnapshot = await getDocs(postQuery);

        if (querySnapshot.empty) {
          setError("Post not found");
          return;
        }

        const postData = {
          id: querySnapshot.docs[0].id,
          ...querySnapshot.docs[0].data(),
        };

        setPost(postData);
      } catch (error) {
        console.error("Error fetching post:", error);
        setError("Error loading post");
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  if (loading) return <div className="text-center">Loading...</div>;
  if (error) return <div className="text-center">{error}</div>;
  if (!post) return <div className="text-center">Post not found</div>;

  return (
    <main>
      <div className="line-top line-bottom">
        <div className="main-inner">
          <article className="blog-post">
            {post.imageUrl && (
              <img
                src={post.imageUrl}
                alt={post.title}
                className="blog-post-image"
              />
            )}
            <h1>{post.title}</h1>
            <div className="blog-post-meta">
              <span>{post.author}</span>
              <span> • </span>
              <span>{post.createdAt.toDate().toLocaleDateString()}</span>
              <span> • </span>
              <span>{post.readTimeMins} min read</span>
            </div>
            <div className="blog-post-content">
              <ReactMarkdown children={post.content} />
            </div>
          </article>
        </div>
      </div>
    </main>
  );
}
